var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCutingNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3C10.5523 3 11 3.44772 11 4V9H37.5858L42.2929 4.29289C42.6834 3.90237 43.3166 3.90237 43.7071 4.29289C44.0976 4.68342 44.0976 5.31658 43.7071 5.70711L39 10.4142V37H44C44.5523 37 45 37.4477 45 38C45 38.5523 44.5523 39 44 39H39V44C39 44.5523 38.5523 45 38 45C37.4477 45 37 44.5523 37 44V39H10C9.44772 39 9 38.5523 9 38V11H4C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9H9V4C9 3.44772 9.44772 3 10 3ZM11 11V35.5858L35.5858 11H11ZM37 12.4142L12.4142 37H37V12.4142Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutingNv);
export default __webpack_public_path__ + "static/media/Cuting_nv.4555b3b33d52da2ac13b41d3d52fdf49.svg";
export { ForwardRef as ReactComponent };